import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/FooterScrollButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/HomeNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/finn.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/vercel/path0/node_modules/swr/dist/index/config-12s-Bi4rgVRk.mjs");
